<template>
  <div class="custom-header-title">
    <h4>Wasabi Accounts</h4>
    <div
      ref="info"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title="For the most part, locations that are Corporate, Centers, and Shops should have Wasabi accounts."
      class="custom-info-icon"
    >
      <i class="fas fa-info-circle"></i>
    </div>
  </div>
  <account-header :page-sizes="pageSizes" @search="getAccounts" @add="newAccount" @delete="confirmDeletion" />
  <div class="table-responsive" :class="{ disabled: isLoading }">
    <div class="custom-listing" :style="listingHeight">
      <z-table
        v-model="records"
        class="table table-bordered table-striped"
        :is-single-row-detail="true"
        :is-header-fixed="isHeaderFixed"
        :sort-by="sortBy"
        :order-by="orderBy"
        :columns="tableColumnsName"
        :detail-column-class="detailColumnClass"
        :loading="isLoading"
        @sort="setOrder"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <input v-model="props.row.isChecked" type="checkbox" class="custom-checkbox" @change="checkedAccount(props.row)" />
          </td>
          <th scope="row" class="custom-column-60">
            <a href="#" @click="showAccount(props.row.acctNum)">{{ props.row.acctNum }}</a>
          </th>
          <td>{{ props.row.acctName }}</td>
          <td>{{ props.row.firm }}</td>
          <td>{{ formatSource(props.row.source) }}</td>
          <td>
            <span v-if="props.row.firmName === null || props.row.firmName.trim() === ''" class="custom-missing-data" title="missing location">
              <i class="fas fa-exclamation-triangle text-danger"></i>
            </span>
            {{ props.row.firmName }}
          </td>
          <td>{{ props.row.firmType }}</td>
          <td>{{ formatDate(props.row.createTime) }}</td>
          <td class="text-right">
            <span v-if="props.row.numObjects === null" class="custom-missing-data" title="potentially, missing bucket">
              <i class="fas fa-exclamation-triangle text-danger"></i>
            </span>
            {{ props.row.numObjects }}
          </td>
          <td class="text-right">{{ props.row.numBytes }}</td>
          <td class="custom-column-60">
            <a href="#" @click="editAccount(props.row.acctNum)">edit</a>
          </td>
        </template>
        <!-- <template #detail="props">
          <user-current-locations :user="props.row.user" />
        </template> -->
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
  <dialog-account v-model="actionAccount" @closing="closeModal" @edit="gotoEdit" @applied="applied" />
  <dialog-add v-model="actionAdd" @closing="closeModal" @saved="savedAccount" />
  <dialog-edit v-model="actionEdit" @closing="closeModal" @saved="savedAccount" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import ZTable from '@/components/utilities/elements/Table.vue'
import AccountHeader from './AccountHeader.vue'
import DialogAccount from './forms/DialogAccount.vue'
import DialogAdd from './forms/DialogAdd.vue'
import DialogEdit from './forms/DialogEdit.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import globals from '@/plugins/globals'
import { Tooltip } from 'bootstrap'
import moment from 'moment'
export default {
  name: 'AccountListing',
  components: {
    ZTable,
    AccountHeader,
    DialogAccount,
    DialogAdd,
    DialogEdit,
    ConfirmDelete
  },
  data() {
    return {
      confirmDeleteTitle: 'Confirm Account Deletion',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion:
        'Are you sure you wish to Permanently Delete checked accounts? NOTE: there is a rate limit of 10 account deletions per minute.',
      actionDelete: null,
      actionAccount: null,
      actionAdd: null,
      actionEdit: null,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60'
    }
  },
  mounted() {
    new Tooltip(this.$refs.info)
    this.resetAccounts()
    let data = {
      startDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      saveToAccounts: true
    }
    this.getUtilizationBuckets(data)
    this.getAccounts()
  },
  computed: {
    ...mapState(wasabiStore, ['loading', 'listParams', 'accounts', 'account']),
    isLoading() {
      return this.loading.accounts
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    records() {
      return this.accounts
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'acctNum',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'acctNum',
          label: '#',
          sortable: true,
          class: 'custom-column-80'
        },
        { field: 'acctName', label: 'Name', sortable: false },
        { field: 'firm', label: 'Id', sortable: false },
        { field: 'source', label: 'Partner', sortable: false },
        { field: 'firmName', label: 'Location', sortable: true },
        { field: 'firmType', label: 'Type', sortable: true },
        { field: 'createTime', label: 'Created', sortable: true },
        { field: 'numObjects', label: '# Objects', sortable: true, class: 'text-right' },
        { field: 'numBytes', label: 'Bytes', sortable: true, class: 'text-right' },
        { field: 'acctNum', label: '', sortable: false }
      ]
      return columns
    }
  },
  methods: {
    ...mapActions(wasabiStore, [
      'resetAccounts',
      'getAccounts',
      'getAccount',
      'deleteAccounts',
      'setListParam',
      'getUtilizationBuckets',
      'getUtilizationStatus',
      'resetAccount',
      'setAccount'
    ]),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    formatSource(data) {
      let source = null
      if (data) {
        if (data === 'Calibrate' || data === 'TestDrive') {
          source = 'Legacy'
        } else {
          source = data.replace('Calibrate', '').replace('TestDrive', '')
        }
      }
      return source
    },
    closeModal() {
      this.actionDelete = null
      this.actionAccount = null
      this.actionAdd = null
      this.actionEdit = null
    },
    async setOrder(column, sortBy) {
      this.setListParam({
        name: 'page',
        value: 1
      })
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.getAccounts()
    },
    showInactive(isInactive) {
      let _data = null
      if (isInactive) {
        _data = 'Y'
      }
      return _data
    },
    checkedAccount(row) {
      let data = {
        name: 'Checked',
        value: row.isChecked,
        id: row.acctNum
      }
      this.setAccount(data)
    },
    async showAccount(acctNum) {
      this.resetAccount()
      await this.getAccount(acctNum)
      this.actionAccount = true
    },
    async editAccount(acctNum) {
      this.resetAccount()
      await this.getAccount(acctNum)
      this.actionEdit = true
    },
    gotoEdit() {
      this.actionAccount = null
      this.actionEdit = true
    },
    async applied() {
      this.actionAccount = null
      await this.getAccounts()
    },
    async savedAccount(acctNum) {
      this.actionAdd = null
      this.actionEdit = null
      this.resetAccount()
      if (acctNum) {
        await this.getAccount(acctNum)
        this.actionAccount = true
      }
    },
    newAccount() {
      this.actionAdd = true
    },
    confirmDeletion() {
      this.actionDelete = true
    },
    async performDeletion() {
      this.actionDelete = false
      let response = await this.deleteAccounts()
      await this.getAccounts()
      if (response) {
        if (response.toLowerCase().indexOf('too many') > 0) {
          alert(response)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header-title {
  display: flex;
}
.custom-info-icon {
  margin-left: 10px;
  color: #0a58ca;
}
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 500px;
  height: 500px;
}
.custom-header {
  position: sticky;
  top: 0;
}
.custom-missing-data {
  position: absolute;
  top: 0;
  left: 10px;
}
</style>
